import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../servicestypes/webdevelopment/webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import Machineimage from '../../../assests/machine learning.jpeg';

const Machinelearning= () => {
  return (
    <Card className="webdevelopment-card">
      {/* Left side with image */}
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="Machine Learning and AI Solutions"
          src={Machineimage}
        />
        
        {/* Contact Information */}
        <div className="contact-info">
          <Typography variant="h6" component="div" gutterBottom className="contact-title">
            Contact Information
          </Typography>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">+919060237575</Typography>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
          </div>
          <div className="contact-item">
            <LocationOnIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Samastipur, Bihar (848101)</Typography>
          </div>
        </div>
        
        {/* Back Button */}
        <Link to="/Services">
          <button className="comic-button">Back</button>
        </Link>
      </Grid>
      
      {/* Right side with content */}
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            Machine Learning and AI Solutions
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Predictive Analytics:</strong> Developing models to predict trends and outcomes based on data.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Natural Language Processing (NLP):</strong> Implementing NLP for chatbots, sentiment analysis, and text processing.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Computer Vision:</strong> Developing image recognition and object detection systems.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Recommendation Systems:</strong> Building personalized recommendation engines for products, content, or services.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Automated Decision-Making:</strong> Implementing AI-driven systems for automated decision processes.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Data Preprocessing and Analysis:</strong> Cleaning and analyzing data to extract valuable insights.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Model Training and Deployment:</strong> Training machine learning models and deploying them into production.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>AI-Powered Chatbots:</strong> Creating chatbots that understand and respond to user queries.
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Machinelearning;
